module.exports = __webpack_public_path__ + "img/scjl@3x.0cce3fe8.png";